import { JSX } from "react";

export const ValidateRole = ({
  children,
  userRoles,
  expectedRoles,
  errorElement,
}: {
  children: JSX.Element | string | number | undefined;
  userRoles?: UserRoleType[];
  expectedRoles?: UserRoleType[];
  errorElement?: JSX.Element | string | number | undefined;
}) => {
  if (expectedRoles && expectedRoles.length > 0) {
    if (!userRoles || !userRoles.some((role) => expectedRoles.includes(role))) {
      return errorElement;
    }
  }
  return children;
};